import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import common from "../assets/css/common.module.css";
import { Loader } from "../../components/Loader";
import { NavLink, useNavigate } from "react-router-dom";
import { postData1 } from "../../services";
import { Pagination } from "../Common";

export const PaymentList = () => {
  const navigate = useNavigate();
  const [orderlistData, setOrderListData] = useState([]);
   const [perPage, setPerPage] = useState(20);
  const [sortedData, setSortedData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // console.log("uus",orderlistData)
  useEffect(() => {
    (async () => {
      const config = { _page: currPage, _limit: perPage };
      const res = await postData1("admin/payment_list/", config, true, true);
      setOrderListData(res?.data?.data);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
      setLoader(false);
    })();
  }, [currPage, perPage]);

  console.log(orderlistData)

  // Apply sorting to the whole dataset
  useEffect(() => {
    let sortedData = [...orderlistData];
    if (sortConfig.key) {
      sortedData.sort((a, b) => {
        const valA = a[sortConfig.key] ?? "";
        const valB = b[sortConfig.key] ?? "";

        if (typeof valA === "string") {
          return sortConfig.direction === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        } else {
          return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }
      });
    }
    setSortedData(sortedData);
  }, [orderlistData, sortConfig]);

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "⇅";
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  // Paginate the sorted data
  const paginateData = (data) => {
    if (!Array.isArray(data)) return [];
    return data;
  };

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>PAYMENT MANAGEMENT</h1>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => handleSort("id")}>
            PAYMENT ID {getSortIcon("id")}
          </span>
          <span onClick={() => handleSort("product_detail.equip_name")}>
            PRODUCT {getSortIcon("product_detail.equip_name")}
          </span>
          <span onClick={() => handleSort("buyer_firstname")}>
            BUYER {getSortIcon("buyer_firstname")}
          </span>
          <span onClick={() => handleSort("product_detail.seller_firstname")}>
            SELLER {getSortIcon("product_detail.seller_firstname")}
          </span>
          <span onClick={() => handleSort("created_date")}>
            INITIATE DATE {getSortIcon("created_date")}
          </span>
          <span onClick={() => handleSort("total")}>
            AMOUNT {getSortIcon("total")}
          </span>
          <span onClick={() => handleSort("payment_status")}>
            STATUS {getSortIcon("payment_status")}
          </span>
          <span>DETAIL</span>
        </div>

        {paginateData(sortedData).map((data, index) => (
          <div className={styles.itemData} key={index}>
            <span>{data?.id}</span>
            <span>{data?.product_detail?.equip_name}</span>
            <span>{data?.buyer_firstname}</span>
            <span>{data?.product_detail?.seller_firstname}</span>
            <span>{new Date(data?.created_date).toLocaleDateString()}</span>
            <span>{data?.total}</span>
            <span>
              <span className={common.customStyle}>
                {data?.payment_status === 1
                  ? "Pending"
                  : data?.payment_status === 2
                  ? "Partial"
                  : data?.payment_status === 3
                  ? "Completed"
                  : "None"}
              </span>
            </span>
            <span style={{ cursor: "pointer" }}>
              <NavLink to="viewpayment/" state={{ item: data }}>View</NavLink>
            </span>
          </div>
        ))}
      </div>
      <Pagination
        total={paging?.total}
        perPage={perPage}
        setPerPage={setPerPage}
        currPage={currPage}
        setCurrPage={setCurrPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
      />
      {loader && <Loader />}
    </section>
  );
};
